import { render, staticRenderFns } from "./modalAprobarCambios.vue?vue&type=template&id=3d4fb357"
import script from "./modalAprobarCambios.vue?vue&type=script&lang=js"
export * from "./modalAprobarCambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports